import $ from "$";
import React from "react";
import { render } from "react-dom";
import classnames from "classnames";
import { Row, Col, Spin, message } from "antd";

import { callApi } from "../wea-tools/callApi";
import { getEmAudioOrVideo } from "../wea-tools/emTools";
import WindowFunc from "../wea-tools/window";
import {
  desensitization,
  encryption,
  replaceEncryption,
  ENCRYPTION_CODE
} from "../wea-tools/Encry.base";
import WeaQrcode from "../wea-qrcode";
import WeaNewScroll from "../wea-new-scroll";
import WeaLocaleProvider from "../wea-locale-provider";
import WeaAlertPage from "../wea-alert-page";
import { defaultIcon, createQRCode, sendMsgToPC } from "./util";
import middleware from "../../middleware";
import WeaTextareaAuth from "../base/wea-textarea-auth";

const getLabel = WeaLocaleProvider.getLabel;

let win = WindowFunc.getTop();
if (window.location.href.indexOf("em_auth_userid") >= 0) {
  win = window;
}
const doc = win.document;

const bodyWrap = doc.createElement("div");
bodyWrap.id = "wea_popover_hrm_inbody";
doc.body.appendChild(bodyWrap);

let instances = [];
let wrap = null;
let target = null;

let props = {
  inDialog: false,
  hasParent: false,
  // 接口
  userid: "",
  userinfo: "",
  fieldInfo: "",
  validate: {},
  emJoinStatus: window.emJoinStatus || {},
  bigImgWidth: 142,
  bigImgHeight: 274,
  // 内部
  // visible: false,
  showSQR: false,
  loading: true,
  imgLoading: false,
  showBigImg: false,
  hasRight: true,
  // 定位
  x: -1000,
  y: -1000,
  targetHeight: 0,
  targetWidth: 0,
  pWidth: 0,
  pHeight: 0,
  pTop: 0,
  pLeft: 0,
  winW: doc.body.clientWidth,
  winH: doc.body.clientHeight
};

const getInstances = () => {
  const instance = instances.filter(({ p, c }) => p.isEqualNode(wrap));
  if (instance.length === 1) return instance[0];
  return null;
};

const getParentStyle = () => {
  const wraps = $(target).closest(".wea-popover-hrm-relative-parent");
  props.inDialog = false;
  if (wraps.length === 1) {
    wrap = wraps[0];
    if (!getInstances()) {
      instances.push({ p: wrap, c: null });
    }
    props.hasParent = true;
    props.pWidth = wraps.width();
    props.pHeight = wraps.height();
    props.pTop = wraps.offset().top;
    props.pLeft = wraps.offset().left;
    const dialog = wraps.closest(".ant-modal-body");
    if (dialog.length === 1) {
      props.inDialog = true;
      wrap = bodyWrap;
      if (!getInstances()) {
        instances.push({ p: wrap, c: null });
      }
      props.pWidth = 0;
      props.pHeight = 0;
      props.pTop = 0;
      props.pLeft = 0;
    }
  } else {
    wrap = bodyWrap;
    if (!getInstances()) {
      instances.push({ p: wrap, c: null });
    }
    props.pWidth = 0;
    props.pHeight = 0;
    props.pTop = 0;
    props.pLeft = 0;
  }
};

class Card extends React.Component {
  state = {
    visible: false
  };
  componentDidMount() {
    this.timer = setTimeout(() => {
      this.setState({ visible: true });
      //   props.visible = true;
      //   this.forceUpdate();
      if (this.timer) {
        clearTimeout(this.timer);
      }
    }, 100);
    window.document.addEventListener("click", this.clickHandle);
    window.addEventListener("resize", this.onResize);
    window.addEventListener("hashchange", this.handleHashChange);
    if (win !== window) {
      doc.addEventListener("click", this.clickHandle);
      win.addEventListener("resize", this.onResize);
      win.addEventListener("hashchange", this.handleHashChange);
    }
  }
  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    window.document.removeEventListener("click", this.clickHandle);
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("hashchange", this.handleHashChange);
    if (win !== window) {
      doc.removeEventListener("click", this.clickHandle);
      win.removeEventListener("resize", this.onResize);
      win.removeEventListener("hashchange", this.handleHashChange);
    }
  }
  onResize = () => {
    getParentStyle();
    this.forceUpdate();
  };
  handleHashChange = () => {
    this.setState({ visible: false });
    // props.visible = false;
    // this.forceUpdate();
  };
  clickHandle = e => {
    if (
      !e.target.isEqualNode(target) &&
      $(this.refs.wea_popover_hrm_card).find(e.target).length === 0
    ) {
      // 点击的不是触发节点 && 节点不在当前卡片上
      this.setState({ visible: false });
      // props.visible = false;
      // this.forceUpdate();
    }
  };
  onLoad = e => {
    const bigImgWidth = e.target.naturalWidth || 142;
    const bigImgHeight = e.target.naturalHeight || 274;
    // 图片防压缩处理
    if (this.smallImg && bigImgWidth / bigImgHeight !== 2 / 3) {
      const stl = this.smallImg.getAttribute("style");
      const newStl =
        bigImgWidth / bigImgHeight > 2 / 3
          ? "width:100%;height:auto;"
          : "height:100%;width:auto;";
      this.smallImg.setAttribute("style", stl ? `${stl};${newStl}` : newStl);
    }
    props = { ...props, bigImgWidth, bigImgHeight };
    this.forceUpdate();
  };
  onError = () => {
    if (props.userinfo) {
      props.userinfo.userimg = defaultIcon[props.userinfo.sex];
      this.forceUpdate();
    }
  };
  onPopoverHrmCusBtnClick = type => {
    const { userid } = props;
    getEmAudioOrVideo(userid, type === "voice" ? 1 : 2, () => {
      this.setState({ visible: false, showGroupModal: false });
    });
  };
  getThemeThemeInfoCls = () => {
    let themeThemeInfo = window.localStorage["theme-themeInfo"];
    const languageidweaver = window.localStorage["languageidweaver"];
    let themeThemeInfoCls = "";
    if (themeThemeInfo && languageidweaver != "7") {
      themeThemeInfo = JSON.parse(themeThemeInfo);
      const themeFontSize = themeThemeInfo.themeFontSize || "12";
      themeThemeInfoCls = "wea-popover-hrm-info-en-f" + themeFontSize;
    }
    return themeThemeInfoCls;
  };
  getTitle = value => {
    if (desensitization(value)) {
      // value = ENCRYPTION_CODE;
      value = "";
    } else if (encryption(value)) {
      // value = replaceEncryption(value);
      value = "";
    }
    return value;
  };
  getValue = value => {
    if (desensitization(value)) {
      return (
        <WeaTextareaAuth
          style={{ display: "inline-block" }}
          ecId={`${this.props.ecId || ""}_WeaTextareaAuth@1m5zxf`}
          value={value}
        />
      );
    } else if (encryption(value)) {
      value = replaceEncryption(value);
    }
    return value;
  };
  render() {
    const { className, style } = this.props;
    const {
      userid,
      userinfo,
      fieldInfo,
      showSQR,
      // visible,
      x,
      y,
      targetHeight,
      loading,
      imgLoading,
      pTop,
      pLeft,
      winW,
      winH,
      validate,
      showBigImg,
      bigImgWidth,
      bigImgHeight,
      emJoinStatus,
      hasRight,
      hasParent,
      inDialog
    } = props;
    const _emJoinStatus = emJoinStatus ? window.emJoinStatus : {};

    const { visible } = this.state;
    const _pLeft = pLeft || 0;
    const _pTop = pTop || 0;
    const gender = {
      "Mr.": `${getLabel("28473", "男")}`,
      "Ms.": `${getLabel("28474", "女")}`
    };
    const sex = { "Mr.": "icon-coms-men", "Ms.": "icon-coms-women" };
    // Dialog dragable using translate, so position fixed & top + 50(title)
    const nowStyle = hasParent
      ? {
          // display: visible ? 'block' : 'none',
          // opacity: visible ? 1 : 0,
          position: inDialog ? "fixed" : "absolute",
          left: winW - x <= 450 ? winW - 450 : x - _pLeft,
          top: winH - y <= 280 ? y - 280 - _pTop : y + targetHeight - _pTop
        }
      : {
          // display: visible ? 'block' : 'none',
          // opacity: visible ? 1 : 0,
          position: "fixed",
          left: winW - x <= 450 ? winW - 450 : x,
          top: winH - y <= 280 ? y - 280 : y + targetHeight
        };
    nowStyle.transformOrigin = `${((x - _pLeft - nowStyle.left) / 424) *
      100}% ${y <= nowStyle.top + _pTop ? 0 : "100%"}`;
    const bigHeight = bigImgHeight > winH * 0.8 ? winH * 0.8 : bigImgHeight;
    const bigWidth = (bigHeight * bigImgWidth) / bigImgHeight;
    const bigImgStyle = showBigImg
      ? {
          width: bigWidth,
          height: bigHeight,
          left:
            nowStyle.left + bigWidth >= winW - (hasParent ? _pLeft : 0)
              ? winW - (hasParent ? _pLeft : 0) - bigWidth - nowStyle.left - 20
              : bigWidth > 142
              ? (bigWidth - 142) / 2 > nowStyle.left + _pLeft
                ? -(nowStyle.left + _pLeft - 20)
                : (142 - bigWidth) / 2
              : -2,
          top:
            nowStyle.top + bigHeight >= winH - (hasParent ? _pTop : 0)
              ? winH - (hasParent ? _pTop : 0) - bigHeight - nowStyle.top - 20
              : bigHeight > 214
              ? (214 - bigHeight) / 2
              : -2,
          opacity: 1,
          transformOrigin: "50% 50%",
          transition: "all .3s cubic-bezier(.645,.045,.355,1)"
        }
      : {
          width: "100%",
          height: "100%",
          left: 0,
          top: 0,
          opacity: 0,
          transition: "all .2s cubic-bezier(.645,.045,.355,1)"
        };
    const cls = classnames(
      className,
      "wea-popover-hrm-wrapper",
      `wea-popover-hrm-wrapper-${visible ? "show" : "hide"}`
    );
    const themeThemeInfoCls = this.getThemeThemeInfoCls();
    let defaultRightInfo = (
      <div
        className={`wea-popover-hrm-info ${window.localStorage[
          "languageidweaver"
        ] != "7" && "wea-popover-hrm-info-en"} ${themeThemeInfoCls}`}
      >
        <p>
          <span title={getLabel("27511", "部门")}>
            {getLabel("27511", "部门")}:
          </span>
          <a
            href={`${window.ecologyContentPath ||
              ""}/spa/hrm/engine.html#/hrmengine/organization?showTree=false&isView=1&type=department&id=${
              userinfo.departmentid
            }`}
            target="_blank"
            // className='text-elli'
            title={this.getTitle(userinfo.departmentName)}
          >
            {this.getValue(userinfo.departmentName)}
          </a>
        </p>
        <p>
          <span title={getLabel("33553", "分部")}>
            {getLabel("33553", "分部")}:
          </span>
          <a
            href={`${window.ecologyContentPath ||
              ""}/spa/hrm/engine.html#/hrmengine/organization?showTree=false&isView=1&type=subcompany&id=${
              userinfo.subcompanyid1
            }`}
            target="_blank"
            title={this.getTitle(userinfo.subcompanyName)}
          >
            {this.getValue(userinfo.subcompanyName)}
          </a>
        </p>
        <p>
          <span title={getLabel("6086", "岗位")}>
            {getLabel("6086", "岗位")}:
          </span>
          <a
            href={`${window.ecologyContentPath ||
              ""}/spa/hrm/engine.html#/hrmengine/posts?id=${userinfo.jobtitle}`}
            target="_blank"
            title={this.getTitle(userinfo.jobtitleName)}
          >
            {this.getValue(userinfo.jobtitleName)}
          </a>
        </p>
        <p>
          <span title={getLabel("596", "上级")}>
            {getLabel("596", "上级")}:
          </span>
          <a
            href={`${window.ecologyContentPath ||
              ""}/spa/hrm/index_mobx.html#/main/hrm/card/cardInfo/${
              userinfo.managerid
            }`}
            target="_blank"
            title={this.getTitle(userinfo.managerName)}
          >
            {this.getValue(userinfo.managerName)}
          </a>
        </p>
        <p>
          <span title={getLabel("23247", "状态")}>
            {getLabel("23247", "状态")}:
          </span>
          <span title={this.getTitle(userinfo.statusName)}>
            {this.getValue(userinfo.statusName)}
          </span>
        </p>
        <p>
          <span title={getLabel("422", "手机")}>
            {getLabel("422", "手机")}:
          </span>
          <span title={this.getTitle(userinfo.mobile)}>
            {this.getValue(userinfo.mobile)}
          </span>
        </p>
        <p>
          <span title={getLabel("421", "电话")}>
            {getLabel("421", "电话")}:
          </span>
          <span title={this.getTitle(userinfo.telephone)}>
            {this.getValue(userinfo.telephone)}
          </span>
        </p>
        <p>
          <span title={getLabel("71", "邮件")}>{getLabel("71", "邮件")}:</span>
          <span title={this.getTitle(userinfo.email)}>
            {this.getValue(userinfo.email)}
          </span>
        </p>
      </div>
    );
    if (fieldInfo) {
      let infoList = [];
      let style = {};
      if (fieldInfo.length < 8) {
        let extHeight = (8 - fieldInfo) * 25;
        style = {
          marignTop: Math.floor(extHeight / fieldInfo.length)
        };
      }
      fieldInfo.forEach(element => {
        infoList.push(
          <p style={style}>
            <span title={element.fieldlabel}>{element.fieldlabel}:</span>
            {element.linkurl ? (
              <a
                href={element.linkurl}
                target="_blank"
                title={this.getTitle(element.fieldvalue)}
              >
                {this.getValue(element.fieldvalue)}
              </a>
            ) : (
              <span title={this.getTitle(element.fieldvalue)}>
                {this.getValue(element.fieldvalue)}
              </span>
            )}
          </p>
        );
      });
      defaultRightInfo = (
        <div
          className={`wea-popover-hrm-info ${window.localStorage[
            "languageidweaver"
          ] != "7" && "wea-popover-hrm-info-en"} ${themeThemeInfoCls}`}
        >
          {infoList}
        </div>
      );
    }

    const showSendMsgBtn =
      typeof validate.hasEmessage === "object" &&
      "isValidate" in validate.hasEmessage
        ? validate.hasEmessage.isValidate
        : _emJoinStatus.status &&
          _emJoinStatus.joinStatus &&
          _emJoinStatus.emSwitch !== "0";

    return (
      <div
        ref="wea_popover_hrm_card"
        className={cls}
        style={{ ...nowStyle, ...style }}
      >
        <i
          title={"关闭"}
          className="icon-coms-Clear"
          onClick={e => {
            props = {
              ...props,
              // visible: false,
              showBigImg: false,
              showSQR: false
            };
            this.state.visible = false;
            this.forceUpdate();
            e.stopPropagation && e.stopPropagation();
            e.preventDefault && e.preventDefault();
            e.nativeEvent && e.nativeEvent.preventDefault();
          }}
        />
        <Spin spinning={loading}>
          {hasRight ? (
            window.renderPopoverHrmContent ? (
              window.renderPopoverHrmContent({ ...props })
            ) : userinfo ? (
              <Row>
                <Col className="wea-popover-hrm-left">
                  <div className="wea-popover-hrm-left-img-wrap">
                    <div className="wea-popover-hrm-left-img-wrap-small">
                      <img
                        ref={ref => (this.smallImg = ref)}
                        className="wea-popover-hrm-userimg wea-popover-hrm-userimg-small"
                        alt=""
                        src={
                          imgLoading
                            ? "/images/messageimages/temp/loading_wev8.gif"
                            : userinfo.userimg
                        }
                        onError={this.onError}
                        onLoad={this.onLoad}
                        onClick={() => {
                          if (!imgLoading) {
                            props.showBigImg = true;
                            this.forceUpdate();
                          }
                        }}
                      />
                    </div>
                    <img
                      alt=""
                      className={`wea-popover-hrm-userimg ${
                        showBigImg ? "wea-popover-hrm-userimg-big" : ""
                      }`}
                      style={bigImgStyle}
                      src={userinfo.userimg}
                      onClick={() => {
                        if (!imgLoading) {
                          props.showBigImg = !showBigImg;
                          this.forceUpdate();
                        }
                      }}
                      onError={this.onError}
                    />
                    <div
                      className="wea-popover-hrm-sqr"
                      style={{ display: showSQR ? "block" : "none" }}
                    >
                      <WeaQrcode
                        text={createQRCode(userinfo)}
                        size={105}
                        level={"L"}
                      />
                      <p>{getLabel("385903", "扫描添加联系人")}</p>
                    </div>
                    {validate[37] && validate[37].isValidate ? (
                      <div
                        className="wea-popover-hrm-left-corner"
                        title={
                          showSQR
                            ? getLabel("1290", "返回")
                            : validate[37].validateName
                        }
                        onClick={e => {
                          props.showSQR = !showSQR;
                          this.forceUpdate();
                          // 暂时未测出哪个管用。。
                          e.stopPropagation && e.stopPropagation();
                          e.preventDefault && e.preventDefault();
                          e.nativeEvent && e.nativeEvent.preventDefault();
                        }}
                      >
                        <i
                          className={`icon-coms-${
                            showSQR ? "Revoke2" : "Scan"
                          }`}
                        />
                      </div>
                    ) : null}
                    {window.showPopoverHrmCusBtn && (
                      <div className="wea-popover-hrm-left-video">
                        <div
                          className="wea-popover-hrm-left-video-item"
                          onClick={() => this.onPopoverHrmCusBtnClick("voice")}
                        >
                          <div className="wea-popover-hrm-left-video-item-content">
                            <i className="icon-coms02-coms-voice" />
                          </div>
                        </div>
                        <div
                          className="wea-popover-hrm-left-video-item"
                          onClick={() => this.onPopoverHrmCusBtnClick("video")}
                        >
                          <div className="wea-popover-hrm-left-video-item-content">
                            <i className="icon-coms02-coms-Video" />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="wea-popover-hrm-left-btns">
                    {showSendMsgBtn ? (
                      <span
                        className="wea-popover-hrm-left-btns-btn"
                        onClick={() => sendMsgToPC(userid, 0, "", "")}
                      >
                        <i
                          className="icon-coms-Send-message"
                          title={validate.hasEmessage.validateName}
                        />
                      </span>
                    ) : null}
                    {validate[31] && validate[31].isValidate ? (
                      <span className="wea-popover-hrm-left-btns-btn">
                        <i
                          className="icon-coms-message-o"
                          title={validate[31].validateName}
                          onClick={() =>
                            window.open(
                              `${window.ecologyContentPath ||
                                ""}/spa/smallApp/static/index.html#/main/sms/SendSms?hrmid=${userid}`
                            )
                          }
                        />
                      </span>
                    ) : null}
                    {validate[19] && validate[19].isValidate ? (
                      <span className="wea-popover-hrm-left-btns-btn">
                        <i
                          className="icon-coms-Send-emails"
                          title={validate[19].validateName}
                          onClick={() =>
                            window.open(
                              `${window.ecologyContentPath ||
                                ""}/spa/email/static/index.html#/main/email/new?fromPage=hrmCard&internaltonew=${JSON.stringify(
                                [{ id: userid, type: "resource" }]
                              )}`
                            )
                          }
                        />
                      </span>
                    ) : null}
                    {validate[32] && validate[32].isValidate ? (
                      <span className="wea-popover-hrm-left-btns-btn">
                        <i
                          className="icon-coms-New-schedule-o"
                          title={validate[32].validateName}
                          onClick={() =>
                            window.open(
                              `${window.ecologyContentPath ||
                                ""}/spa/workplan/static/index.html#/main/wp/workPlanCreateSingle?type=create&selectedUser=${userid}`
                            )
                          }
                        />
                      </span>
                    ) : null}
                  </div>
                </Col>
                <Col className="wea-popover-hrm-right">
                  <div className="wea-popover-hrm-title">
                    <a
                      href={`${window.ecologyContentPath ||
                        ""}/spa/hrm/index_mobx.html#/main/hrm/card/cardInfo/${userid}`}
                      title={userinfo.lastname}
                      target="_blank"
                      className="wea-f14"
                      style={{ color: "#2db7f5" }}
                    >
                      {userinfo.lastname}
                    </a>
                    {/*<span  title={`${sex[userinfo.sex]}${userinfo.workcode}`}>{`${sex[userinfo.sex]}${userinfo.workcode}`}</span>*/}
                    <em
                      title={`${gender[userinfo.sex]}`}
                      className={sex[userinfo.sex]}
                    />
                    <span title={this.getTitle(userinfo.workcode)}>
                      {this.getValue(userinfo.workcode)}
                    </span>
                  </div>
                  <WeaNewScroll height={205}>{defaultRightInfo}</WeaNewScroll>
                  <div className="wea-popover-hrm-bottom">
                    {userinfo.isOnline && userinfo.ip
                      ? [
                          <span className="wea-popover-hrm-info-online" />,
                          userinfo.ip
                        ]
                      : null}
                  </div>
                </Col>
              </Row>
            ) : (
              <div style={{ width: 428, height: 274 }} />
            )
          ) : (
            <WeaAlertPage>
              <p>{getLabel(2012, "对不起，您暂时没有权限！")}</p>
            </WeaAlertPage>
          )}
        </Spin>
      </div>
    );
  }
}

window.pointerXY = e => {
  target = e.target;
  getParentStyle();

  let middle = wrap.querySelector(".wea-popover-hrm-middle");
  if (!middle) {
    middle = doc.createElement("div");
    middle.className = "wea-popover-hrm-middle";
    wrap.appendChild(middle);
  }

  /**
   * iframe 内定位，加上 iframeOffsetY iframeOffsetX，导致人力卡片定位偏移
   */
  if (window.top !== window) {
    props.x = $(e.target).offset().left;
    props.y = $(e.target).offset().top;
  } else {
    let iframeOffsetX = 0;
    let iframeOffsetY = 0;
    const iframeOffset = $(window.frameElement).offset();
    if (window.frameElement) {
      iframeOffsetX = iframeOffset.left;
      iframeOffsetY = iframeOffset.top;
    }
    props.x = $(e.target).offset().left + iframeOffsetX;
    props.y = $(e.target).offset().top + iframeOffsetY;
  }
  /* ---------------------------------------------------------- */

  props.targetWidth = e.target.offsetWidth;
  props.targetHeight = e.target.offsetHeight;
  props.winW = doc.body.clientWidth;
  props.winH = doc.body.clientHeight;
  const instance = getInstances();
  if (instance.c) {
    instance.c.state.visible = true;
    // props.visible = true;
  }
  render(
    <Card
      ref={el => {
        instance.c = el;
      }}
    />,
    middle
  );
  e.stopPropagation && e.stopPropagation();
};

let times = 0;
let timer = null;

window.openhrm = id => {
  timer = setTimeout(() => {
    const instance = getInstances();
    if (props.userid !== id) {
      const oldTimes = times;
      const initStates = {
        loading: true,
        imgLoading: true,
        userid: id,
        userinfo: "",
        fieldInfo: "",
        showBigImg: false
      };
      props = { ...props, ...initStates };
      instance && instance.c && instance.c.forceUpdate();
      times++;
      callApi("/api/hrm/simpleinfo/getHrmSimpleInfo", "GET", {
        userid: id
      }).then(res => {
        let newState = { loading: false, hasRight: true };
        props = { ...props, ...newState };
        if (instance && instance.c) {
          if (res.status == "1") {
            const insNow = getInstances();
            if (oldTimes + 1 === times && insNow.p.isEqualNode(instance.p)) {
              if (res.hasRight === false || res.hasRight === "false") {
                newState = {
                  ...newState,
                  hasRight: false
                };
              } else {
                const { simpleInfo: userinfo, validate, fieldInfo } = res;
                userinfo.userimg =
                  validate[36] &&
                  validate[36].isValidate &&
                  userinfo.messageUrls
                    ? userinfo.messageUrls
                    : defaultIcon[userinfo.sex];
                const img = new Image();
                img.onload = img.onerror = () => {
                  props.imgLoading = false;
                  instance.c.forceUpdate();
                };
                img.src = userinfo.userimg;
                newState = {
                  ...newState,
                  userinfo,
                  validate,
                  fieldInfo: fieldInfo || ""
                };
              }
              props = { ...props, ...newState };
              instance.c.forceUpdate();
            } else {
              instance.c.setState({ visible: false });
            }
          } else {
            message.error("人力卡片接口错误！");
            instance.c.forceUpdate();
          }
        }
      });
    } else if (instance && instance.c) {
      props.loading = false;
      instance.c.forceUpdate();
    }
    timer && clearTimeout(timer);
  }, 0);
};

class WeaPopoverHrm extends React.Component {
  static sendMsgToPC = sendMsgToPC;
  static Card = Card;
  render() {
    const { children, className, style } = this.props;
    if (!children) {
      return null;
    }
    return (
      <div
        className={`wea-popover-hrm-relative-parent ${className || ""}`}
        style={style}
        onClick={e => {
          e.stopPropagation && e.stopPropagation();
        }}
      >
        {children || null}
      </div>
    );
  }
}

const Com = middleware(WeaPopoverHrm, "WeaPopoverHrm");

export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-popover-hrm/index.js